import { useSiteContent } from "@/lib/siteContent";

export default function TopBar() {
  const messages = useSiteContent().topBarMessages;
  const safe = messages.length ? messages : [""];
  const loop = [...safe, ...safe, ...safe, ...safe];

  return (
    <div className="w-full bg-[#211C19] text-[#FFFDF9]">
      <div className="relative overflow-hidden py-2">
        <div className="ab-marquee">
          {loop.map((message, index) => (
            <span
              key={`${message}-${index}`}
              className="flex items-center gap-3 whitespace-nowrap px-6 text-[11px] uppercase tracking-[0.18em] md:text-xs"
            >
              <span className="flex h-3 w-3 items-center justify-center">
                <span className="h-1.5 w-1.5 rounded-full bg-[#C5A05A]" />
              </span>
              {message}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}